<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"
                                         :$_em-custom-vuex-mixin_entity="entityState"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // Author Liang Gang Qiang
    // Date 2021-11-24 16:34:50

    import emCommonEditMixin from "@/mixin/em/common/edit";

    export default {
        name: "mintalMesQualitySelfInspectRoastEditView",
        mixins: [emCommonEditMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            entityState() {
                return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
            }
        }
    };
</script>